const EVISITOR = {
  EVISITOR_ARRIVAL_TYPES: 'ARRIVAL_TYPES',
  EVISITOR_COUNTRIES: 'COUNTRIES',
  EVISITOR_DOCUMENT_TYPES: 'DOCUMENT_TYPES',
  EVISITOR_RESIDENCE_TAX_CATEGORIES: 'RESIDENCE_TAX_CATEGORIES',
  EVISITOR_SERVICES: 'SERVICES',
  EVISITOR_OBJECT_CODE: 'EVISITOR_OBJECT_CODE',
  EVISITOR_PARTNER: 'EVISITOR_PARTNER',
  EVISITOR_GUESTS: 'EVISITOR_GUESTS',

  RENTALS_CM_EVISITOR: 'RENTALS_CM_EVISITOR',
};

export default EVISITOR;
